// constants/specialties.js

export const SPECIALTIES = [
  'cardiologie',
  'pneumologie',
  'neurologie',
  'dermatologie',
  'ophtalmologie',
  'ORL',
  'gastro-entérologie',
  'rhumatologie',
  'endocrinologie',
  'néphrologie',
  'hématologie',
  'psychiatrie',
  'pédiatrie',
  'médecine générale',
  'médecine interne',
  'urgences',
  'anesthésie',
  'radiologie',
  'médecine nucléaire',
  'chirurgie générale',
  'chirurgie orthopédique',
  'chirurgie vasculaire',
  'chirurgie cardiaque',
  'gynécologie',
  'urologie'
];


// Grouped specialties for the picker
export const SPECIALTY_GROUPS = [
  {
    largeSpecialty: 'Médecine',
    value: 'medicine',
    specialties: [
      'cardiologie',
      'pneumologie',
      'neurologie',
      'dermatologie',
      'ophtalmologie',
      'ORL',
      'gastro-entérologie',
      'rhumatologie',
      'endocrinologie',
      'néphrologie',
      'hématologie',
      'psychiatrie',
      'pédiatrie',
      'médecine générale',
      'médecine interne',
      'urgences',
      'réanimation',
      'anesthésie',
      'radiologie',
      'médecine nucléaire'
    ]
  },
  {
    largeSpecialty: 'Chirurgie',
    value: 'surgery',
    specialties: [
      'chirurgie générale',
      'chirurgie orthopédique',
      'chirurgie vasculaire',
      'chirurgie cardiaque',
      'gynécologie',
      'urologie'
    ]
  },
  {
    largeSpecialty: 'Autre',
    value: 'general',
    specialties: []
  }
];